import { Injectable } from '@angular/core';
import { API_URLS } from '../../../../../../../environments/env-routes';
import { APIHelper } from '../../../../../../../shared/services/api-helper/api-helper.service';
import { SortParams } from '../../../../../../shared/interfaces/sort-params.interface';
import { StorageService } from '../../../../../../../shared/services/storage/storage.service';
import { UploadDocumentsService } from './upload-documents.service';
import * as moment from "moment";
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { BadInput } from 'src/app/v2-node-api/common/bad-input';
import { NotFoundError } from 'src/app/v2-node-api/common/not-found-error';
import { AppError } from 'src/app/v2-node-api/common/app-error';
export interface PaginationParams {
  skipCount: number;
  maxItems: number;
}

@Injectable({
  providedIn: 'root'
})
export class NodesService {
  public rootSite = null;
  public publicId: string;
  private _nodeCache = {};
  private _nodeSiteCache = {};

  constructor(private api: APIHelper, private uploadDocumentsService: UploadDocumentsService, private storage: StorageService, private http: HttpClient) {
  }

  public getSites(): Promise<any> {
    return this.api.requestApi({ action: API_URLS.sites.sites });
  }

  public createSite({
    name,
    description,
    visibility,
    id
  }: {
    name: string;
    description: string;
    visibility: string;
    id: string;
  }): Promise<any> {
    const data = {
      description: description,
      id: id,
      title: name,
      visibility: visibility
    };
    return this.api.requestApi({
      action: API_URLS.sites.create,
      method: 'POST',
      datas: data
    });
  }
  public updateSite(site: any, id: string) {
    const data = {
      title: site.name,
      description: site.description,
      visibility: site.visibility
    }
    return this.api.requestApi({ action: API_URLS.nodes.updateSite.replace(':siteId', id), method: 'PUT', datas: data });

  }

  public getChildren(
    nodeId: string,
    pagination: PaginationParams = {
      maxItems: 25,
      skipCount: 0
    },
    sort: SortParams = null,
    getSource = true
  ): Promise<any> {
    const childrenRoute = API_URLS.nodes.children.replace(':nodeId', nodeId);
    let args =
      `maxItems=${pagination.maxItems}&` +
      `skipCount=${pagination.skipCount}&` +
      `include=path,properties,allowableOperations,permissions,aspectNames,isFavorite&` +
      `includeSource=${getSource}`
      ;

    if (getSource) {
      args += '&' + ((sort) ? `orderBy=isFolder DESC,${sort.sortBy} ${sort.order}` : 'isFolder DESC');
    }

    return this.api
      .requestApi({ action: childrenRoute, queryArgs: args })
      .then(res => {
        if (getSource) {
          return res.list;
        } else {
          return res.list.entries;
        }
      });
  }

  public resolveOne(nodeId: string): Promise<any> {
    const elementRoute = API_URLS.nodes.nodes.replace(':nodeId', nodeId);
    const args =
      'include=path,properties,allowableOperations,permissions,aspectNames,isFavorite&includeSource=true';

    return this.api.requestApi({ action: elementRoute, queryArgs: args });
  }

  public getPath(pathname: string, elements: any[]): any[] {
    elements = this.sanitiezElements(elements);
    const stringsToRemove = [
      'Espace racine/Sites/',
      'documentLibrary/',
      '/documentLibrary'
    ];
    stringsToRemove.forEach(str => {
      pathname = pathname.replace(str, '');
    });

    let arr = pathname.split('/');
    arr = arr.splice(1, arr.length);
    const result = [];

    let idOrigin = '';
    elements.forEach(el => {
      if (el.name === 'documentLibrary') {
        idOrigin = el.id;
      }
    });

    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < elements.length; j++) {
        if (elements[j].name.toLowerCase() === arr[i].toLowerCase()) {
          result.push(elements[j]);
          break;
        }
      }
    }

    result[0].idLibrary = result[0].id;
    result[0].id = idOrigin;

    return result;
  }

  public delete(nodeId, definitive = false): Promise<any> {
    const url = API_URLS.nodes.nodes.replace(':nodeId', nodeId);

    let queryArgs = '';

    if (definitive) {
      queryArgs = 'permanent=true';
    }

    return this.api.requestApi({ action: url, method: 'DELETE', queryArgs }).then(res => {
      return true;
    });
  }

  public updateOrder(parentId, newOrder): Promise<any> {
    const url = API_URLS.nodes.nodes.replace(':nodeId', parentId);
    const data = {
      properties: {
        'ng:order': JSON.stringify(newOrder)
      }
    };
    const args =
      'include=path%2Cproperties%2CallowableOperations%2Cpermissions';

    return this.api.requestApi({
      action: url,
      method: 'PUT',
      datas: data,
      queryArgs: args
    });
  }

  async getSite(nodeId: string, originalNodeId?: string) {
    let n;
    originalNodeId = originalNodeId || nodeId;
    if (!nodeId) {
      return null;
    }

    if (this._nodeSiteCache[nodeId]) {
      return this._nodeSiteCache[nodeId];
    } else {
      n = await this.resolveOne(nodeId);
      // in case the node is already a site
      if (this.isSite(n)) {
        this._nodeSiteCache[originalNodeId] = n;
        return n;
      }

      // else the check up its parents
      return await this.getSite(n.parentId, originalNodeId);
    }
  }

  async getNodeParentsArray(node) {
    if (typeof node === 'string') {
      node = await this.resolveOne(node);
    }
    if (!node) {
      return false;
    }
    const parentsArray = [node];
    let currentNode = { ...node };
    while (currentNode.parentId) {
      let n;
      if (this._nodeCache[currentNode.parentId]) {
        n = this._nodeCache[currentNode.parentId];
      } else {
        n = await this.resolveOne(currentNode.parentId);
        this._nodeCache[currentNode.parentId] = n;
      }
      if (n) {
        parentsArray.unshift(n);
        currentNode = { ...n };
        /*
         * This part is to prevent documentLibrary node from showing
         * in the breadcrumb and make the site element take to the
         * documentLibrary.
         * */
        if (this.isSite(currentNode)) {
          parentsArray[0].id = parentsArray[1].id;
          parentsArray.splice(1, 1);
          break;
        }
      }
    }
    return parentsArray;
  }

  public async uploadAlreadyExistingDocument({ fileToSend, destinationId }) {
    // Aller récupérer les childrens de la destination
    const childrens = await this.getChildren(destinationId);

    // Retrouver le noeud portant le même nom que le file actuel
    let nodeToFind = null;

    childrens.entries.forEach((node) => {
      if (node.entry.name === fileToSend.name) {
        nodeToFind = node;
        return;
      }
    });

    if (!nodeToFind) {
      return;
    }

    // Récupérer le contenu binaire du contenu que l'on déplace et l'appliquer en tant que version dans le target
    const url = API_URLS.nodes.downloadsContent.replace(':id', fileToSend.id);
    const content = await this.api.requestApi({
      action: url,
      queryArgs: 'attachment: true',
      addFormat: false,
      httpParams: { responseType: 'text' }
    });

    // Créer une nouvelle version du noeud avec la valeur du fichier actuel
    const url_upload = this.api.url + API_URLS.nodes.upload;
    const datas = {
      filename: fileToSend.name,
      destination: null,
      createdirectory: true,
      majorVersion: false,
      username: null,
      overwrite: true,
      thumbnails: null,
      updatenameandmimetype: false,
      updateNodeRef: `workspace://SpacesStore/${nodeToFind.entry.id}`
    };

    const blob = new Blob([content], { type: 'application/json' });
    // const result = await this.api.requestApi({action: API_URLS.nodes.upload, method: 'POST', datas});
    this.uploadDocumentsService.uploadBinary({ file: blob, method: 'POST', url: url_upload, parameters: datas });

    return nodeToFind;
  }

  isSite(node) {
    return (node.nodeType === 'st:site');
  }

  private sanitiezElements(elements: any[]) {
    const result = [];
    elements.forEach(el => {
      if (el.name !== 'Company Home' && el.name !== 'Sites') {
        result.push(el);
      }
    });

    return result;
  }

  notifyMail(data) {
    return this.api.requestApi({
      action: API_URLS.nodes.notify,
      method: 'POST',
      datas: data
    });
  }

  async uploadNewVersion({ fileToSend, destinationId, newblob, isMajor, comment, id }) {

    let file = fileToSend;
    let base_url = this.api.url + API_URLS.nodes.content.replace(':nodeId', id);

    const params = `?name=${fileToSend.name}&overwrite=true&comment=${comment}&majorVersion=isMajor`;

    const url = base_url + params;

    const parameters = {
      'relativePath': '',
      'name': fileToSend.name,
      'majorVersion': true,
      'updatenameandmimetype': false,
      'overwrite': true,
      'comment': comment
    };

    return this.uploadBinary({ file, method: 'PUT', url, parameters });

  }

  public uploadBinary({ file, method, url, parameters }: { file: any, method: string, url: string, parameters: object }): Promise<any> {
    const form = new FormData();
    form.append('filedata', file, file.name);

    for (const prop in parameters) {
      if (!parameters.hasOwnProperty(prop)) {
        continue;
      }

      form.append(prop, parameters[prop]);
    }

    const bearer = this.storage.getAsync({ key: 'bearer' });
    let header = new HttpHeaders();
    header = header.set('Authorization', 'Basic ' + bearer);
    header = header.set('Content-type', 'application/octet-stream');
    const req = new HttpRequest(method, url, form, {
      reportProgress: true,
      headers: header
    });
    return new Promise((resolve, reject) => {
      this.http.request(req).toPromise().then(request => {
        resolve(request);
      }).catch(reject);
    });
  }

  mergeDocuments(datas) {
    return this.api.requestApi({
      action: API_URLS.nodes.fusion,
      method: 'POST',
      datas: datas
    });
  }

  exportExcel(datas){
    return this.api.requestApi({
      action: API_URLS.nodes.generateExcel,
      method: 'POST',
      datas: datas
    });
  }

  public loadFile(nodeId, token, isPublic): Promise<any> {
    let contentRoute: string;
    let args2 = '';
    let headerObject = {};

    if (!isPublic) {
      contentRoute = API_URLS.nodes.content.replace(':nodeId', nodeId);
      args2 = '?alf_ticket=' + token + '&attachment=false';

      const bearer = this.storage.getAsync({ key: 'bearer' });

      headerObject = {
        Authorization: 'Basic ' + bearer
      };
    } else {
      contentRoute = API_URLS.sharedLink.content.replace(':sharedId', nodeId);
    }

    return this.http
      .get(this.api.url + contentRoute + args2, {
        headers: new HttpHeaders(headerObject),
        responseType: 'blob'
      })
      .toPromise();
  }

}
